import AnsweredQuestion from '../../../../settings/components/FAQ/AnsweredQuestion';

const AnsweredQuestionPage = () => {
    return <AnsweredQuestion />;
};

export default AnsweredQuestionPage;
